import { stripLocalePrefix } from "./i18n-locale-routes";

export const CORPORATE_CENTER_PREFIX = "/seer/corporate-center";
export const MENTOR_JOIN_PREFIX = "/seer/mentor-join";

/** 使用独立头部布局、需隐藏全局底栏的路由前缀 */
export const STANDALONE_SECTION_PREFIXES = [CORPORATE_CENTER_PREFIX, MENTOR_JOIN_PREFIX];

export function isCorporateCenterPath(path) {
	if (!path) return false;
	const normalized = stripLocalePrefix(path);
	return (
		normalized === CORPORATE_CENTER_PREFIX || normalized.startsWith(`${CORPORATE_CENTER_PREFIX}/`)
	);
}

export function isMentorJoinPath(path) {
	if (!path) return false;
	const normalized = stripLocalePrefix(path);
	return normalized === MENTOR_JOIN_PREFIX || normalized.startsWith(`${MENTOR_JOIN_PREFIX}/`);
}

/** mentor-join / corporate-center：隐藏全局底栏、展示头部语言切换 */
export function isStandaloneSectionPath(path) {
	if (!path) return false;
	const normalized = stripLocalePrefix(path);
	return STANDALONE_SECTION_PREFIXES.some(
		prefix => normalized === prefix || normalized.startsWith(`${prefix}/`)
	);
}

/**
 * 合作中心子页跳转（整页导航）。
 * 入驻等页含 Teleport/n-modal/RichEditor 且 keep-alive 缓存时，SPA 切换在生产环境易触发 insertBefore 白屏。
 */
export function navigateCorporateCenterPage(to) {
	if (!import.meta.client) return;
	const rawPath = typeof to === "string" ? to : to?.path;
	if (!rawPath) return;

	const localePrefix = window.location.pathname.match(/^\/(tw|en)(?=\/)/)?.[0] ?? "";
	const normalized = rawPath.startsWith("/") ? rawPath : `/${rawPath}`;
	const target =
		localePrefix && !normalized.startsWith(`${localePrefix}/`)
			? `${localePrefix}${normalized}`
			: normalized;

	window.location.assign(target);
}
